module.exports = __webpack_public_path__ + "static/media/Protagonist Logo Text_White.7151e19b.svg";